exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-select-wrapper select[data-v-626f9750] {\n  border-radius: 0;\n  padding-right: 53px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  -webkit-border-radius: 0;\n  cursor: pointer;\n}\n.select-icon[data-v-626f9750] {\n  position: absolute;\n  right: 20px;\n  top: 16px;\n}\n", ""]);

// exports
